import { Injectable } from '@angular/core';
import { ID, Store, StoreConfig } from '@datorama/akita';
import { ThinTask } from '@state/task';

export interface Workflow {
  created_at_formatted: string;
  created_at: string;
  description: string;
  id: ID;
  investment_id?: ID;
  investor_email?: string;
  investor_id?: string;
  investor_is_current_user?: boolean;
  investor_name?: string;
  message: string;
  notes?: string;
  started_at?: string;
  state: 'unstarted';
  success_cta?: string;
  success_redirect_url?: string;
  success_message?: string;
  tasks: ThinTask[];
  title: string;
  updated_at_formatted: string;
  updated_at: string;
}

export interface WorkflowState {
  workflow?: Workflow;
  loading: boolean;
  mobileAsideVisible: boolean;
}

export function createInitialState(): WorkflowState {
  return {
    loading: true,
    mobileAsideVisible: false,
    workflow: undefined
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'workflow', resettable: true })
export class WorkflowStore extends Store<WorkflowState> {
  constructor() {
    super(createInitialState());
  }
}
